import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CheckCircleIcon from '../../../../../icons/check-circle.svg';
import SvgIcon from '@material-ui/core/SvgIcon';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import './AdditionalBenifitsInput.scss';
import { makeStyles } from "@material-ui/core/styles";
import { alpha } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    activeBorder: {
        borderColor: alpha(theme.palette.primary.main, .5),
    },
    primaryText: {
        color: theme.palette.primary.main
    }
}));

export default function AdditionalBenifitsInput(props) {

    const classes = useStyles();

    return (
        <Button
            variant={props.value ? 'outlined' : 'contained'}
            className={`shadow benifits-card-input ${props.value ? `'active ${classes.activeBorder}` : 'inactive'} ${props.mobileWide ? 'wide-sm' : ''}`}
            onClick={props.onClick}
            aria-pressed={props.value}
            aria-labelledby={props.title}
        // color="primary"
        >
                <div className="heading-wrapper">
                    <span className={`title ${classes.primaryText}`}>{props.title}</span>
                    <span className={`premium ${classes.primaryText}`}><span className="text">Additional</span><span><sup>$</sup><b>{props.premium}</b>/mo</span></span>
                </div>
                <ul>
                    {props.benifits.map((data, index) => {
                        return (
                            <li key={index}><span>{data.title}<span className={`${classes.primaryText}`}>{" "}{data.amount}</span></span></li>
                        )
                    })}
                </ul>
                {props.value ? (
                    <SvgIcon component={CheckCircleIcon} color="primary" name={props.productName} className="check" />
                ) : (
                        <SvgIcon component={RadioButtonUncheckedIcon} color="disabled" className="unCheck" />
                    )}
        </Button>
    );
}

AdditionalBenifitsInput.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    mobileWide: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/Helpers/Input/AdditionalBenifitsInput.js